export default "__VITE_ASSET__DittQOR1__"